import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataProtectionNoticeEndpoint } from '../constants/data-protection-notice-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { RequestHeader } from '../../../../constants';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeItemFileService {
  constructor(private http: WrapperHttpService) {}

  getDpnItemFile(dpnItemFileId: string): Observable<string> {
    return this.http
      .withLoading()
      .get<string>(
        `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Version}/${dpnItemFileId}${DataProtectionNoticeEndpoint.Content}`,
        { responseType: 'text' },
      );
  }

  downloadDpnItemFile(dpnItemFileId: string): Observable<string> {
    const url = `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Version}/${dpnItemFileId}${DataProtectionNoticeEndpoint.Content}`;

    return this.http.get<string>(url, { responseType: 'text' });
  }

  getLastDpnItemFile(country: string): Observable<string> {
    return this.http
      .withLoading()
      .get<string>(
        `${API_URL}${DataProtectionNoticeEndpoint.Base}${DataProtectionNoticeEndpoint.Public}${DataProtectionNoticeEndpoint.Version}${DataProtectionNoticeEndpoint.Country}/${country}${DataProtectionNoticeEndpoint.Content}`,
        {
          responseType: 'text',
          headers: new HttpHeaders({
            [RequestHeader.SkipInterceptor]: '',
          }),
        },
      );
  }
}
